import Const from 'constants';

import {LineupPlayers as NFLClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nfl/classic';
import {LineupPlayers as NFLSingleGameLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nfl/single-game';

const Factory = {
    getComponent(sportConfig) {
        if (sportConfig.isSportNfl()) {
            if (sportConfig.isGameTypeClassic()) {
                return NFLClassicLineupPlayers;
            } else if (sportConfig.isGameTypeSingleGame()) {
                return NFLSingleGameLineupPlayers;
            }
        }

        throw new Error(`Factory ERR: unknown sport ${sportConfig.getSport()}`);
    },
};

export {Factory};
